// extracted by mini-css-extract-plugin
module.exports = {"snackbar":"Notification_snackbar__KyeEk","snackbar--success":"Notification_snackbar--success___wnKM"};